// extracted by mini-css-extract-plugin
module.exports = {"photo":"Petroleum_photo__2MPQr","info":"Petroleum_info__2OYfm","step":"Petroleum_step__2sl0b","wrapper":"Petroleum_wrapper__iReNS"};